import React from 'react';
import { Link } from 'react-router-dom';
import { OCCASION_SHOWCASE, slugifyCategory } from '../utils/constants';
import './OccasionShowcase.css';

const OccasionShowcase: React.FC = () => (
  <section className="section occasion-section">
    <div className="container">
      <div className="section-eyebrow">Every Occasion, Covered</div>
      <h2 className="section-title">Shop by Occasion</h2>
      <div className="ornament"><span>✦</span></div>
      <div className="occasion-grid">
        {OCCASION_SHOWCASE.map((card, i) => (
          <Link key={card.title} to={`/products/${slugifyCategory(card.category)}`} className="occasion-card">
            <svg className="bg" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid slice">
              <defs>
                <linearGradient id={`occ-grad-${i}`} x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stopColor={card.gradientFrom} />
                  <stop offset="1" stopColor={card.gradientTo} />
                </linearGradient>
              </defs>
              <rect width="300" height="400" fill={`url(#occ-grad-${i})`} />
            </svg>
            <i className={`fa-solid ${card.icon} occasion-icon`} aria-hidden="true" />
            <div className="occasion-body">
              <span className="occasion-eyebrow">{card.eyebrow}</span>
              <h3 className="occasion-title">{card.title}</h3>
              <span className="occasion-link">Explore →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default OccasionShowcase;
